import { APPINDICATORS } from '../constants';

export const dismissAlert = () => ({ type: APPINDICATORS.HIDE_ALERT });



// WEBPACK FOOTER //
// ./src/actions/alert.js